var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Process"},[_c('my_title',{attrs:{"content":_vm.title}}),_c('time_line',{attrs:{"process":_vm.process}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }